<template>
  <validation-provider
    v-slot="{ errors }"
    :name="label || 'This'"
    :rules="rules"
    v-bind="providerProps"
    mode="eager"
    v-show="innerShouldShow"
    :vid="'validate-'+fieldAssignmentId"
  >
    <v-text-field
      v-model="innerValue"
      v-bind="vProps"
      :error-messages="errors"
    ></v-text-field>
  </validation-provider>
</template>

<script>
import formMixin from '../formMixin'

export default {
  name: 'TypeZipcode',
  mixins: [formMixin],
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  },
  computed: {
    defaults() {
      return {
        label: this.innerLabel,
        persistentHint: true,
      }
    },
    rules() {
      return (this.enableValidation) ? {
        ...(this.componentProps.required && { required: true }),
        zipcode: {
          country: this.hasCountry ? this.validation.countryCode : '',
        },
      } : {}
    },
    hasCountry() {
      if (typeof this.validation === 'object') {
        return Object.hasOwnProperty.call(this.validation, 'countryCode')
      }

      return false
    },
  },
}
</script>
